import { useState, useRef } from "react";

export function usePaymentModals() {
  const [cvvModalOpen, setCvvModalOpen] = useState(false);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isApplePayModalOpen, setIsApplePayModalOpen] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [isBottomSheetClosing, setIsBottomSheetClosing] = useState(false);
  const hasManuallyClosedApplePayModalRef = useRef(false);

  const openCvvModal = (): void => setCvvModalOpen(true);
  const closeCvvModal = (): void => {
    setCvvModalOpen(false);
  };

  const openCardModal = (): void => setIsCardModalOpen(true);
  const closeCardModal = (): void => {
    setIsCardModalOpen(false);
  };

  const openApplePayModal = (): void => {
    setIsApplePayModalOpen(true);
    hasManuallyClosedApplePayModalRef.current = false;
  };
  const closeApplePayModal = (): void => {
    setIsApplePayModalOpen(false);
    hasManuallyClosedApplePayModalRef.current = true;
  };

  const openBottomSheet = (): void => setIsBottomSheetOpen(true);
  const closeBottomSheet = (): void => {
    setIsBottomSheetClosing(true);
    setTimeout(() => {
      setIsBottomSheetClosing(false);
      setIsBottomSheetOpen(false);
    }, 300);
  };

  return {
    cvvModalOpen,
    isCardModalOpen,
    isApplePayModalOpen,
    isBottomSheetOpen,
    isBottomSheetClosing,
    hasManuallyClosedApplePayModalRef,
    openCvvModal,
    closeCvvModal,
    openCardModal,
    closeCardModal,
    openApplePayModal,
    closeApplePayModal,
    openBottomSheet,
    closeBottomSheet,
  };
}
